import { DatabaseEntities } from "../../../common/models/database-entities.model";


export class GrainBoxRollingTypes extends DatabaseEntities<GrainBoxRollingTypes> {
    value: string;
}
